// extracted by mini-css-extract-plugin
export default {"h1":"Nav_h1__RUt0G","h2":"Nav_h2__wPfyF","h3":"Nav_h3__MlYVR","h4":"Nav_h4__dfRMT","h5":"Nav_h5__E1Xb6","h6":"Nav_h6__b56-7","nav":"Nav_nav__CfI3F","pillar":"Nav_pillar__A6vl9"};